import { UserProfileDto, UserRole } from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_CALCULATION } from "../domain";
import { CalculationDataResponse, GetCalculationDataParams } from "./types";

import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_CALCULATION_DATA = "GET_CALCULATION_DATA";

const AZURE_LOGIC_APP_URL =
  "https://gm-flows.azurewebsites.net:443/api/fetch_calc_data/triggers/When_an_HTTP_request_is_received/invoke?api-version=2022-05-01&sp=%2Ftriggers%2FWhen_an_HTTP_request_is_received%2Frun&sv=1.0&sig=Tj9czj7EH3miIaiHsa9M2WPMhf8bZSrYnFnT7ALij2Y";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

export const fetchCalculationData = async ({
  client,
}: GetCalculationDataParams): Promise<CalculationDataResponse> => {
  const response = await fetch(AZURE_LOGIC_APP_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ client }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const useGetCalculationData = (
  user: UserProfileDto | null,
  client: string,
): {
  calculationData: CalculationDataResponse | undefined;
  calculationDataEnabled: boolean;
  calculationError: Error | null;
  refetchCalculationData: () => void;
  isLoadingCalculationData: boolean;
  isFetchingCalculationData: boolean;
  isSuccessCalculationData: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles) && !!client;
  const queryResult = useQuery<CalculationDataResponse, Error>({
    queryKey: [DOMAIN_CALCULATION, ACTION_GET_CALCULATION_DATA, client],
    queryFn: () => fetchCalculationData({ client }),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    calculationData: queryResult.data,
    calculationDataEnabled: enabled,
    calculationError: queryResult.error,
    refetchCalculationData: queryResult.refetch,
    isLoadingCalculationData: queryResult.isLoading,
    isFetchingCalculationData: queryResult.isFetching,
    isSuccessCalculationData: queryResult.isSuccess,
  };
};
